const locationPopupCategory = "Buy_used_cars_B2C_Location";

export const locationComponentCta = {
    event: "new_location",
    eventAction: "location | open_popup"
};

export const searchBarLocation = {
    event: "new_location",
    eventCategory: locationPopupCategory,
    eventAction: "location | start_typing"
};

export const citySelection = {
    event: "new_location",
    eventCategory: locationPopupCategory,
    eventAction: "location | select_searched_city"
};

export const zeroSearchResults = {
    event: "new_location",
    eventCategory: locationPopupCategory,
    eventAction: "location | zero_search_results"
};

export const popularCity = {
    event: "new_location",
    eventCategory: locationPopupCategory,
    eventAction: "location | popular_city"
};

export const otherCities = {
    event: "new_location",
    eventCategory: locationPopupCategory,
    eventAction: "location | other_cities"
};
